import * as angular from "angular";
import {IController} from "angular";
import {ResourcesService} from "../../services/resources-service.service";

export class ResourceAllocationSelectCtrl implements IController {

  selectedResourceAllocation: any;
  from: any;
  to: any;
  skills: any;
  branchIds: string[];
  resourceIds: any;
  serviceAreaIds: any;
  options: any[];
  optionIds: string[];
  isRequired: boolean;
  isDisabled: boolean;
  isActive: boolean;
  excludeIds: string[];
  excludeRouted: boolean;
  ngPlaceholder: string;
  onChange: Function;


  private resourcesAllocationsRef: any;
  public selectedText: any;

  /* @ngInject */
  constructor(private $mdPanel, private $resourceAllocationsInstances, private $element, private $filter, private resourcesService: ResourcesService) {
    this.resourcesAllocationsRef = this.$resourceAllocationsInstances();
  }

  $onInit() {
    this._setSelected();
  };

  $onChanges(changes) {
    if ((changes.selectedResourceAllocation && !changes.selectedResourceAllocation.isFirstChange())
      || (changes.branchIds && !changes.branchIds.isFirstChange())) {
      this._setSelected();
    }
  };


  onShowPanel($event) {

    if (!!this.isDisabled) {
      return;
    }

    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-select-input')
      .withAnimation(this.$mdPanel.animation.FADE);

    const selectedAllocationRef = this.selectedResourceAllocation;
    const fromRef = this.from;
    const toRef = this.to;
    const skillsRef = this.skills;
    const branchIdsRef = this.branchIds;
    const resourceIdsRef = this.resourceIds
    const serviceAreaIdsRef = this.serviceAreaIds
    const optionsRef = this.options;
    const optionIdsRef = this.optionIds;
    const isActiveRef = this.isActive;
    const excludeIdsRef = this.excludeIds;
    const excludeRoutedRef = this.excludeRouted;
    const ngPlaceholderRef = this.ngPlaceholder;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-select-filter-panel ' +
          'type="ctrl.typeRef" ' +
          'selected-id="ctrl.selectedAllocationRef" ' +
          'branch-ids="ctrl.branchIdsRef" ' +
          'depot-ids="ctrl.depotIdsRef" ' +
          'options="ctrl.optionsRef" ' +
          'option-ids="ctrl.optionIdsRef" ' +
          'ng-placeholder="ctrl.ngPlaceholderRef" ' +
          'panel-ref="ctrl.mdPanelRef" ' +
          'query-map="ctrl.queryMapRef" ' +
          'exclude-ids="ctrl.excludeIdsRef">' +
          '</bringoz-select-filter-panel>',
      controller: function () {
        this.typeRef = 'resourceAllocation';
        this.selectedAllocationRef = selectedAllocationRef;
        this.branchIdsRef = branchIdsRef;
        this.optionsRef = optionsRef;
        this.optionIdsRef = optionIdsRef;
        this.isActiveRef = isActiveRef
        this.excludeIdsRef = excludeIdsRef;
        this.ngPlaceholderRef = ngPlaceholderRef;
        this.queryMapRef = {
          from: fromRef,
          to: toRef,
          skills: skillsRef,
          resourceIds: resourceIdsRef,
          serviceAreaIds: serviceAreaIdsRef,
          excludeRouted:excludeRoutedRef,
          isActive:isActiveRef
        }
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, resourceAllocation) => {
        if (resourceAllocation === 'clickOutsideToClose' || resourceAllocation === 'escapeToClose') {
          resourceAllocation = selectedAllocationRef;
        }
        if (!resourceAllocation) {
          this.onChange({resourceAllocation: undefined, id: undefined});
          panel.destroy();
        } else {
          if (!!this.options) {
            this.onChange({resourceAllocation: resourceAllocation, id: resourceAllocation.id});
            panel.destroy();
          } else {
            this.onChange({resourceAllocation: resourceAllocation, id: resourceAllocation.id});
            panel.destroy();
          }
        }
      }
    };

    this.$mdPanel.open(config);
  }

  onResetFilter() {
    this.onChange({resourceAllocation: undefined});
  }

  private _setSelected() {
    if (!!this.selectedResourceAllocation) {
      this._setSelectedText();
    } else {
      this.selectedResourceAllocation = undefined;
      this._setSelectedText();
    }
  }

  private _setSelectedText() {
    if (!this.selectedResourceAllocation) {
      this.selectedText = '';
      return;
    }
    this.selectedText = `${this.selectedResourceAllocation.resourceName} - ${this.$filter('bringozDate')({startTime: this.selectedResourceAllocation.schedule.startTime}, 'startTime', true)}`
  }


}

angular
  .module('bringoz.admin.resources')
  .component('resourceAllocationSelect', {
    require: {
      form: '^form'
    },
    bindings: {
      selectedResourceAllocation: '<',
      from: '<?',
      to: '<?',
      skills: '<?',
      branchIds: '<?',
      resourceIds: '<?',
      serviceAreaIds: '<?',
      options: '<?',
      optionIds: '<?',
      isActive: '<?',
      isRequired: '<?',
      isDisabled: '<?',
      excludeIds: '<?',
      excludeRouted: '<?',
      ngPlaceholder: '<?',
      onChange: '&'
    },
    template: require('./resource-allocation-select.html').default,
    controller: ResourceAllocationSelectCtrl
  });
